import React from 'react';
import { Avatar } from '@readyplayerme/visage';
// import { extractAvatarIdFromUrl } from '@/main/utils/avatar-utils';
import { ErrorBoundary } from 'react-error-boundary';
import { CircleSpinner } from '..';
import { Vector3 } from 'three';
const logError = (error, info) => {
    console.log('Error boundary error: ', error, info);
};
const RenderAvatar = ({ avatarUrl, isFemale = false }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(ErrorBoundary, { fallback: React.createElement("div", { dangerouslySetInnerHTML: {
                    __html: `<model-viewer id="modelviewer" alt="Ready Player Me Avatar" src="${avatarUrl}" shadow-intensity="1" camera-controls touch-action="pan-y"></model-viewer>`
                } }), onError: logError },
            React.createElement(Avatar, { loader: () => React.createElement(CircleSpinner, null), modelSrc: avatarUrl, animationSrc: `https://readyplayerme.github.io/visage/${isFemale ? 'fe' : ''}male-idle.glb`, 
                // poseSrc="https://readyplayerme.github.io/visage/male-pose-standing.glb"
                environment: "lobby", scale: 1, 
                // shadows
                headMovement: true, cameraZoomTarget: new Vector3(0.11, 0, 3), 
                // cameraTarget={0.8}
                cameraInitialDistance: 0, style: { background: 'transparent' }, ambientLightColor: "#fff5b6", dirLightColor: "#002aff", emotion: {
                    eyeSquintLeft: 0.4,
                    eyeSquintRight: 0.2,
                    mouthSmileLeft: 0.37,
                    mouthSmileRight: 0.36,
                    mouthShrugUpper: 0.27,
                    browInnerUp: 0.3,
                    browOuterUpLeft: 0.37,
                    browOuterUpRight: 0.49
                } }))));
};
export default RenderAvatar;
